interface Period {
  firstDate: string | number | Date;
  lastDate: string | number | Date;
}

// Purpose: calculate the - fractional - number of months for a period
// Example: period: Jan 4, 2023 - Feb 20, 2024
//          result: 12 months + 4/31 months + 20/28 months = 12.84 months
//

export const calculateBilledMonthFromDates = function (period: Period | null) {
  if (!period) {
    return 0;
  }

  const { firstDate, lastDate } = period;

  const first_date = new Date(firstDate);
  const last_date = lastDate ? new Date(lastDate) : new Date();

  const first_month = first_date.getMonth();
  const first_year = first_date.getFullYear();
  const last_month = last_date.getMonth();
  const last_year = last_date.getFullYear();

  const total_number_of_months =
    (last_year - first_year) * 12 + (last_month - first_month) + 1;

  const number_of_days_in_first_month = new Date(
    first_year,
    first_month + 1,
    0
  ).getDate();
  const number_of_days_in_last_month = new Date(
    last_year,
    last_month + 1,
    0
  ).getDate();

  const number_of_days_in_first_month_billed = number_of_days_in_first_month - first_date.getDate() + 1;
  const number_of_days_in_last_month_billed = last_date.getDate();

  const percentage_billed_days_in_first_month = number_of_days_in_first_month_billed / number_of_days_in_first_month;
  const percentage_billed_days_in_last_month = number_of_days_in_last_month_billed / number_of_days_in_last_month;

  const billed_months =
    total_number_of_months -
    2 +
    percentage_billed_days_in_first_month +
    percentage_billed_days_in_last_month;

  return billed_months;
};
